/* 
 * Just constants to make sure we have a common reference
 */

const ROTA_TYPE_AVAIABLE = 1

/**
 * There is one rota type which is hard coded as marking availablity.
 */
export default ROTA_TYPE_AVAIABLE